var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(91.764706%,26.27451%,20.784314%)",
      fillOpacity: 1
    },
    d: "M 5.554688 2.726562 C 5.554688 3.1875 5.179688 3.5625 4.714844 3.5625 C 4.253906 3.5625 3.878906 3.1875 3.878906 2.726562 C 3.878906 2.261719 4.253906 1.886719 4.714844 1.886719 C 5.179688 1.886719 5.554688 2.261719 5.554688 2.726562 Z M 5.554688 2.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(91.764706%,26.27451%,20.784314%)",
      fillOpacity: 1
    },
    d: "M 5.554688 6.21875 C 5.554688 6.679688 5.179688 7.058594 4.714844 7.058594 C 4.253906 7.058594 3.878906 6.679688 3.878906 6.21875 C 3.878906 5.753906 4.253906 5.378906 4.714844 5.378906 C 5.179688 5.378906 5.554688 5.753906 5.554688 6.21875 Z M 5.554688 6.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(91.764706%,26.27451%,20.784314%)",
      fillOpacity: 1
    },
    d: "M 5.554688 9.710938 C 5.554688 10.175781 5.179688 10.550781 4.714844 10.550781 C 4.253906 10.550781 3.878906 10.175781 3.878906 9.710938 C 3.878906 9.25 4.253906 8.875 4.714844 8.875 C 5.179688 8.875 5.554688 9.25 5.554688 9.710938 Z M 5.554688 9.710938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(91.764706%,26.27451%,20.784314%)",
      fillOpacity: 1
    },
    d: "M 5.554688 13.207031 C 5.554688 13.667969 5.179688 14.042969 4.714844 14.042969 C 4.253906 14.042969 3.878906 13.667969 3.878906 13.207031 C 3.878906 12.742188 4.253906 12.367188 4.714844 12.367188 C 5.179688 12.367188 5.554688 12.742188 5.554688 13.207031 Z M 5.554688 13.207031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.431373%,73.72549%,1.568627%)",
      fillOpacity: 1
    },
    d: "M 8.699219 0.976562 C 8.699219 1.519531 8.261719 1.957031 7.71875 1.957031 C 7.179688 1.957031 6.742188 1.519531 6.742188 0.976562 C 6.742188 0.4375 7.179688 0 7.71875 0 C 8.261719 0 8.699219 0.4375 8.699219 0.976562 Z M 8.699219 0.976562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.431373%,73.72549%,1.568627%)",
      fillOpacity: 1
    },
    d: "M 8.699219 4.472656 C 8.699219 5.011719 8.261719 5.449219 7.71875 5.449219 C 7.179688 5.449219 6.742188 5.011719 6.742188 4.472656 C 6.742188 3.929688 7.179688 3.492188 7.71875 3.492188 C 8.261719 3.492188 8.699219 3.929688 8.699219 4.472656 Z M 8.699219 4.472656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.431373%,73.72549%,1.568627%)",
      fillOpacity: 1
    },
    d: "M 8.699219 7.964844 C 8.699219 8.503906 8.261719 8.941406 7.71875 8.941406 C 7.179688 8.941406 6.742188 8.503906 6.742188 7.964844 C 6.742188 7.425781 7.179688 6.988281 7.71875 6.988281 C 8.261719 6.988281 8.699219 7.425781 8.699219 7.964844 Z M 8.699219 7.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.431373%,73.72549%,1.568627%)",
      fillOpacity: 1
    },
    d: "M 8.699219 11.457031 C 8.699219 12 8.261719 12.4375 7.71875 12.4375 C 7.179688 12.4375 6.742188 12 6.742188 11.457031 C 6.742188 10.917969 7.179688 10.480469 7.71875 10.480469 C 8.261719 10.480469 8.699219 10.917969 8.699219 11.457031 Z M 8.699219 11.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.431373%,73.72549%,1.568627%)",
      fillOpacity: 1
    },
    d: "M 8.699219 15.023438 C 8.699219 15.5625 8.261719 16 7.71875 16 C 7.179688 16 6.742188 15.5625 6.742188 15.023438 C 6.742188 14.480469 7.179688 14.042969 7.71875 14.042969 C 8.261719 14.042969 8.699219 14.480469 8.699219 15.023438 Z M 8.699219 15.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(20.392157%,65.882353%,32.54902%)",
      fillOpacity: 1
    },
    d: "M 11.84375 2.761719 C 11.84375 3.398438 11.328125 3.914062 10.691406 3.914062 C 10.054688 3.914062 9.539062 3.398438 9.539062 2.761719 C 9.539062 2.125 10.054688 1.605469 10.691406 1.605469 C 11.328125 1.605469 11.84375 2.125 11.84375 2.761719 Z M 11.84375 2.761719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(20.392157%,65.882353%,32.54902%)",
      fillOpacity: 1
    },
    d: "M 11.84375 6.253906 C 11.84375 6.890625 11.328125 7.40625 10.691406 7.40625 C 10.054688 7.40625 9.539062 6.890625 9.539062 6.253906 C 9.539062 5.617188 10.054688 5.101562 10.691406 5.101562 C 11.328125 5.101562 11.84375 5.617188 11.84375 6.253906 Z M 11.84375 6.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(20.392157%,65.882353%,32.54902%)",
      fillOpacity: 1
    },
    d: "M 11.84375 9.746094 C 11.84375 10.382812 11.328125 10.898438 10.691406 10.898438 C 10.054688 10.898438 9.539062 10.382812 9.539062 9.746094 C 9.539062 9.109375 10.054688 8.59375 10.691406 8.59375 C 11.328125 8.59375 11.84375 9.109375 11.84375 9.746094 Z M 11.84375 9.746094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(20.392157%,65.882353%,32.54902%)",
      fillOpacity: 1
    },
    d: "M 11.84375 13.238281 C 11.84375 13.875 11.328125 14.394531 10.691406 14.394531 C 10.054688 14.394531 9.539062 13.875 9.539062 13.238281 C 9.539062 12.601562 10.054688 12.085938 10.691406 12.085938 C 11.328125 12.085938 11.84375 12.601562 11.84375 13.238281 Z M 11.84375 13.238281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(25.882353%,52.156863%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 14.988281 4.472656 C 14.988281 5.203125 14.390625 5.800781 13.660156 5.800781 C 12.925781 5.800781 12.332031 5.203125 12.332031 4.472656 C 12.332031 3.738281 12.925781 3.144531 13.660156 3.144531 C 14.390625 3.144531 14.988281 3.738281 14.988281 4.472656 Z M 14.988281 4.472656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(25.882353%,52.156863%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 2.410156 4.472656 C 2.410156 4.859375 2.097656 5.171875 1.710938 5.171875 C 1.324219 5.171875 1.011719 4.859375 1.011719 4.472656 C 1.011719 4.085938 1.324219 3.773438 1.710938 3.773438 C 2.097656 3.773438 2.410156 4.085938 2.410156 4.472656 Z M 2.410156 4.472656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(25.882353%,52.156863%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 2.410156 7.964844 C 2.410156 8.351562 2.097656 8.664062 1.710938 8.664062 C 1.324219 8.664062 1.011719 8.351562 1.011719 7.964844 C 1.011719 7.578125 1.324219 7.265625 1.710938 7.265625 C 2.097656 7.265625 2.410156 7.578125 2.410156 7.964844 Z M 2.410156 7.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(25.882353%,52.156863%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 2.410156 11.457031 C 2.410156 11.84375 2.097656 12.15625 1.710938 12.15625 C 1.324219 12.15625 1.011719 11.84375 1.011719 11.457031 C 1.011719 11.074219 1.324219 10.761719 1.710938 10.761719 C 2.097656 10.761719 2.410156 11.074219 2.410156 11.457031 Z M 2.410156 11.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(25.882353%,52.156863%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 14.988281 7.964844 C 14.988281 8.699219 14.390625 9.292969 13.660156 9.292969 C 12.925781 9.292969 12.332031 8.699219 12.332031 7.964844 C 12.332031 7.230469 12.925781 6.636719 13.660156 6.636719 C 14.390625 6.636719 14.988281 7.230469 14.988281 7.964844 Z M 14.988281 7.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(25.882353%,52.156863%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 14.988281 11.457031 C 14.988281 12.191406 14.390625 12.785156 13.660156 12.785156 C 12.925781 12.785156 12.332031 12.191406 12.332031 11.457031 C 12.332031 10.726562 12.925781 10.132812 13.660156 10.132812 C 14.390625 10.132812 14.988281 10.726562 14.988281 11.457031 Z M 14.988281 11.457031 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAi);
export default __webpack_public_path__ + "static/media/google-ai.9d3acc707fed266ec37cfe51a46896f3.svg";
export { ForwardRef as ReactComponent };